import { z } from "zod";
import { canonicalTwinBoundaryJson } from "./twin-logic.js";
const sha256Schema = z.string().regex(/^[0-9a-f]{64}$/u);
const memberArchivePathSchema = z.string().min(1).max(512).refine((value) => {
    const parts = value.split("/");
    return !value.startsWith("/") && !value.endsWith("/") && !value.includes("\\")
        && parts.every((part) => part.length > 0 && part !== "." && part !== "..");
}, "Archive member paths must be canonical and relative.");
export const twinAuthoringMemberArchiveKindSchema = z.enum([
    "authored_members",
    "frozen_bundle",
    "emitted_release",
]);
export const twinAuthoringMemberArchiveV1Schema = z.object({
    artifact_kind: z.literal("twin_authoring_member_archive"),
    schema_version: z.literal("1.0.0"),
    archive_kind: twinAuthoringMemberArchiveKindSchema,
    members: z.array(z.object({
        path: memberArchivePathSchema,
        content_base64: z.string().max(64 * 1_024 * 1_024)
            .regex(/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/u),
        sha256: sha256Schema,
        bytes: z.number().int().nonnegative().max(48 * 1_024 * 1_024).safe(),
    }).strict()).max(512),
    member_ledger_sha256: sha256Schema,
}).strict().superRefine((archive, context) => {
    if (archive.archive_kind !== "authored_members" && archive.members.length === 0) {
        context.addIssue({
            code: "custom",
            path: ["members"],
            message: "Frozen bundle and emitted release archives cannot be empty.",
        });
    }
    const paths = archive.members.map(({ path }) => path);
    const sorted = [...paths].sort();
    if (new Set(paths).size !== paths.length || JSON.stringify(paths) !== JSON.stringify(sorted)) {
        context.addIssue({
            code: "custom",
            path: ["members"],
            message: "Archive members must have unique paths in sorted order.",
        });
    }
});
export function canonicalTwinAuthoringMemberArchiveJson(input) {
    return canonicalTwinBoundaryJson(twinAuthoringMemberArchiveV1Schema.parse(input));
}
